import { SortDirection } from '@/types';
import { Icon, IconType } from '@alpine-iq/ui-library';
import React from 'react';
import styled from 'styled-components';

export type SortIconProps = {
	sortOrder: SortDirection | undefined;
	setOrder?: (order: SortDirection | undefined) => void;

	prority?: number;

	ascendingIcon?: IconType;
	descendingIcon?: IconType;
	style?: React.CSSProperties;
};

export default function SortIcon({ sortOrder, setOrder, prority, ascendingIcon, descendingIcon, ...props }: SortIconProps): JSX.Element {
	// const ascIcon: IconType = ascendingIcon ?? 'ARROW_DOWN';
	// const descIcon: IconType = descendingIcon ?? 'ARROW_DOWN';
	const ascIcon: IconType = ascendingIcon ?? 'CHEVRON_DOWN';
	const descIcon: IconType = descendingIcon ?? 'CHEVRON_DOWN';
	let iconType: IconType | undefined = undefined;
	if (sortOrder === 'asc') {
		iconType = ascIcon;
	} else if (sortOrder === 'desc') {
		iconType = descIcon;
	}

	const handleClick = () => {
		setOrder?.(getNextSortOrder(sortOrder));
	};

	return (
		<Wrapper
			className="sort-icon"
			onClick={handleClick}
			{...props}
		>
			{prority && <StyledNumber>{prority}</StyledNumber>}
			{iconType && (
				<Icon
					type={iconType}
					height={14}
					width={14}
					style={{
						cursor: 'pointer',
						transition: 'transform 0.3s ease, opacity 0.3s ease',
						transform: descIcon === ascIcon ? `scaleY(${sortOrder === 'asc' ? -1 : 1})` : undefined,
						opacity: sortOrder ? 1 : undefined,
						...props.style,
					}}
				/>
			)}
		</Wrapper>
	);
}

// Wrapper for relative positioning
const Wrapper = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	position: relative;
`;

// Styled Number that floats to the top right of the icon, super small
const StyledNumber = styled.span`
	position: absolute;
	top: -0.25rem;
	right: -0.25rem;
	font-size: 0.575rem;
	color: #475467;
	opacity: 0.75;
	z-index: 1;
`;

export const getNextSortOrder = (current: SortDirection | undefined): SortDirection | undefined => {
	// if (current === 'asc') {
	// 	return 'desc';
	// }
	// if (current === 'desc') {
	// 	return undefined;
	// }
	// return 'asc';
	// Reverse the current order
	if (current === 'asc') {
		return undefined;
	}
	if (current === 'desc') {
		return 'asc';
	}
	return 'desc';
};
